import { Trash2, Plus, Minus } from "lucide-react";

import { Button } from "@/shared/ui/kit/button";
import { Input } from "@/shared/ui/kit/input";
import { Skeleton } from "@/shared/ui/kit/skeleton";

export function CartItemSkeleton() {
  return (
    <div className="flex gap-4 p-4 border-b last:border-b-0 items-center">
      {/* Image skeleton */}
      <div className="shrink-0 size-20 relative">
        <Skeleton className="size-full rounded-md" />
        {/* Country and service icons skeleton */}
        <div className="absolute top-1 right-1 flex gap-1 z-10">
          <Skeleton className="w-5 h-5 rounded-full" />
          <Skeleton className="w-5 h-5 rounded-full" />
        </div>
      </div>

      {/* Content skeleton */}
      <div className="flex flex-col justify-between min-w-0 space-y-1.5 w-full">
        {/* Title and delete button row */}
        <div className="flex items-center justify-between gap-2">
          <Skeleton className="h-4 w-3/4" />
          <Button
            variant="ghost"
            size="icon"
            className="size-8 shrink-0"
            disabled
          >
            <Trash2 className="size-4" />
          </Button>
        </div>

        {/* Metadata skeleton */}
        <div className="flex gap-2">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-12" />
        </div>

        {/* Price and quantity controls row */}
        <div className="flex items-center gap-2 w-full justify-between">
          <Skeleton className="h-4 w-24" />
          <div className="flex items-center gap-1 rounded-md shrink-0">
            <Button
              variant="secondary"
              size="icon"
              className="size-7 h-7"
              disabled
            >
              <Minus className="size-4" />
            </Button>
            <Input
              type="text"
              value="1"
              disabled
              className="w-12 h-7 text-center bg-accent/80 text-sm font-medium p-0 border-0"
            />
            <Button
              variant="secondary"
              size="icon"
              className="size-7 h-7"
              disabled
            >
              <Plus className="size-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function CartListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="divide-y">
      {Array.from({ length: count }).map((_, index) => (
        <CartItemSkeleton key={index} />
      ))}
    </div>
  );
}
